import React          from 'react';
import _              from 'lodash'
import numeral        from 'numeral';
import classnames     from 'classnames'
import PropTypes      from 'prop-types'
import {START}        from 'pu-data/QuoteSteps'
import RadioComponent from 'pu-react/components/base/RadioComponent';
import ImagePcbNoon   from 'images/pcb_noon.svg'

class PriceMatrixCell extends React.Component {
  constructor(props) {
    super(props);
    this.unitPrice = this.unitPrice.bind(this);
    this.cellClass = this.cellClass.bind(this);
    this.showUnitPrice = this.showUnitPrice.bind(this);
    this.identifier = this.identifier.bind(this);
    this.renderInput = this.renderInput.bind(this);
    this.renderEmpty = this.renderEmpty.bind(this);
    this.isSelected = this.isSelected.bind(this);
    this.totalPrice = this.totalPrice.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  unitPrice() {
    const {price} = this.props
    if (!price || price.total === undefined) return null;

    const up = price.total / this.props.quantity;
    return Math.round(up * 100) / 100;
  }

  showUnitPrice() {
    const unitPrice = this.unitPrice()
    if (unitPrice === null) return ''

    // return `$${numeral(unitPrice).format('0.00')}`;

    // const supplier = this.props.lineItem.get('product_key');
    let ico;
    const price = `$${numeral(unitPrice).format('0.00')}`;
    if (this.props.quoteStep !== START && _.startsWith(this.props.price.quote_config_key, 'plx')) {
      ico = <img src={ImagePcbNoon} alt="cutoff-time-noon"/>;
    }

    return <span>{price}{ico}</span>;
  }

  totalPrice() {
    const {price} = this.props
    if (!price || price.total === undefined) return null;

    return price.total
  }

  cellClass() {
    const {price} = this.props
    if (!price || !price.quote_config_key) return '';

    const productKey = price.product_key;
    let klass = {};

    if (this.props.quoteStep !== START && isManager) {
      if (productKey === 'fabrication-us-excell') {
        klass.xcll = true;
      } else if (productKey === 'fabrication-us-ampel') {
        klass.mpl = true;
      }
    }

    return classnames(this.props.className, klass)
  }

  identifier() {
    const {price} = this.props
    if (!price || price.quote_config_key === undefined) return null;

    const supplier = price.quote_config_key;
    return `${this.props.quantity}-${this.props.leadTime}-${supplier}`;
  }

  onChange() {
    if (!this.props.onPriceSelect) {
      // TODO: show error and report to managers
      return;
    }
    if (this.totalPrice() <= 0) {
      return;
    }
    this.props.onPriceSelect(this.onSelectData());
  }

  onSelectData() {
    const {price} = this.props
    if (!price) return {}

    return {
      quantity: this.props.quantity,
      leadTime: this.props.leadTime,
      quote_config_key: price.quote_config_key,
      supplier: price.product_key,
      parametersChanged: this.props.parametersChanged,
      unitPrice: this.unitPrice(),
      total: this.totalPrice(),
      row_selected: price.row_line_item,
      column_selected: price.col_line_item,
    };
  }

  isSelected() {
    const {price, parameters} = this.props;

    if (!parameters || parameters.row_selected === undefined || parameters.column_selected === undefined || parameters.quote_config_key === undefined || parameters.supplier_selected === undefined) {
      return false
    }

    if (price.row_line_item === undefined || price.col_line_item === undefined || price.quote_config_key === undefined || price.product_key === undefined) {
      return false
    }

    return _.toInteger(parameters.row_selected) === _.toInteger(price.row_line_item) &&
      _.toInteger(parameters.column_selected) === _.toInteger(price.col_line_item) &&
      parameters.quote_config_key === price.quote_config_key &&
      parameters.supplier_selected === price.product_key
  }

  renderInput() {
    return (
      <RadioComponent
        inputId={`price-${this.identifier()}`}
        label={this.showUnitPrice()}
        name={this.props.name}
        onChange={this.onChange}
        inputClassName={this.props.inputClassName}
        checked={this.isSelected()}
        groupName="prices_f" />
    );
  }

  renderEmpty() {
    return '\u00A0';
  }

  render() {
    const total = this.totalPrice();
    let field;
    if (total == null) {
      field = this.renderEmpty();
    } else {
      field = this.props.quoteStep === START || total > 0 ?
        this.renderInput() :
        this.renderEmpty();
    }
    return <td className={this.cellClass()}>{field}</td>;
  }
}

PriceMatrixCell.defaultProps = {
  name: 'price_matrix',
  inputClassName: 'ignore-on-quote',
};

PriceMatrixCell.propTypes = {
  quoteStep: PropTypes.string.isRequired,
  price: PropTypes.object,
  parameters: PropTypes.object.isRequired,
  quantity: PropTypes.number.isRequired,
  leadTime: PropTypes.string.isRequired,
  parametersChanged: PropTypes.bool.isRequired,
  name: PropTypes.string,
  inputClassName: PropTypes.string,
  onPriceSelect: PropTypes.func.isRequired,
}

export default PriceMatrixCell;
